const SKILL_ENUM = ["Singer", "Songwriter", "Producer", "DJ", "Drummer", "Guitarist", "Bassist", "Keyboardist", "Pianist", "Woodwind player", "Brass wind player", "Violinist", "Cellist", "Other"]

export default SKILL_ENUM;

